export const showSpinner = (el) => {
    const spinner = document.createElement('percy-spinner');
    spinner.classList.add('large');
    (el !== null && el !== void 0 ? el : document.body).appendChild(spinner);
};
export const hideSpinner = (el) => {
    var _a;
    (_a = (el !== null && el !== void 0 ? el : document).querySelector('percy-spinner')) === null || _a === void 0 ? void 0 : _a.remove();
};
